<template>
	<inertia-head title="TRC Stock Updates" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Updates</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Exclusive stock updates to become one step ahead with other
						investors
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div v-if="stock_updates.data.length > 0" class="row pb-4 justify-content-center">
			<!--START Posts -->
			<div v-for="stock_update in stock_updates.data" :key="stock_update.stock_update_uuid" class="col-xl-10 col-lg-10 col-md-10 mt-5">
				<div>
					<div
						class="overflow-hidden rounded mb-3 bg-image text-center"
						style="height: 200px;"
					>
					<img :src="stock_update.stock_image_url" class="img-fluid w-100 h-100 img-obj-fit" alt="stock update image">
					</div>
				</div>
				<div class="p-3 pt-0">
					<p class="mb-1 h2"><inertia-link :href="'/member/updates/stock-updates/details/'+stock_update.stock_update_uuid" class="text-dark">{{ stock_update.stock_title }}</inertia-link></p>
					<div class="fs-sm fw-medium text-muted mb-2">
						<span class="me-3 fs-xs">
							<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
							{{ stock_update.date_start }}
						</span>
						<span class="fs-xs">
							<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
							Stock Update
						</span>
					</div>
				</div>
				<div class="p-3 pt-0">
					<div style="white-space: pre; white-space:break-spaces;overflow: hidden;" v-html="stock_update.short_desc"></div>
					<p class="mt-2"><inertia-link :href="'/member/updates/stock-updates/details/'+stock_update.stock_update_uuid">Read More...</inertia-link></p>
				</div>
			</div>
			<nav class="d-flex justify-content-between align-items-center push">
				<inertia-link
					v-if="stock_updates.prev_page_url"
					:href="stock_updates.prev_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !stock_updates.prev_page_url }"
				>
					<i class="fa fa-arrow-left opacity-50 me-1"></i>
					<span>Prev</span>
				</inertia-link>
				<inertia-link
					v-if="stock_updates.next_page_url"
					:href="stock_updates.next_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !stock_updates.next_page_url }"
				>
					<span>Next</span>
					<i class="fa fa-arrow-right opacity-50 ms-1"></i>
				</inertia-link>
			</nav>
			<hr class="d-xl-none" />
			<!-- END Posts -->

		</div>
		<div v-else>
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="m-0 h4 text-danger text-center">No Stock Update Found...</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		stock_updates: Object,
	},
	setup(props) {
		const modal 			= ref(null);
		let stock_updates 		= ref(props.stock_updates);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')

		})

		
		return {
			modal,
			stock_updates
		}
	},
}
</script>
